import React, { useState } from "react";
import SettingsOverview from "./SettingsOverview";
import ProfileSettingsScreen from "./ProfileSettingsScreen";
import NotificationsSettingsScreen from "./NotificationsSettingsScreen";
import LanguageSettingsScreen from "./LanguageSettingsScreen";
import SecuritySettingsScreen from "./SecuritySettingsScreen";
import PasswordSettingsScreen from "./PasswordSettingsScreen";

export default function SettingsTab({
  t,
  parentData,
  form,
  onChange,
  onSave,
  onBack,
  onLogout,
}) {
  const [screen, setScreen] = useState("overview");

  const backToOverview = () => setScreen("overview");
  const openPassword = () => setScreen("password");

  const screenProps = {
    t,
    parentData,
    form,
    onChange,
    onSave,
    onBack: backToOverview,
    onOpenPassword: openPassword,
  };

  return (
    <div className="pp-settings-app pp-family-view">
      {screen === "overview" && (
        <SettingsOverview
          t={t}
          onBack={onBack}
          onNavigate={setScreen}
          onLogout={onLogout}
        />
      )}
      {screen === "profile" && <ProfileSettingsScreen {...screenProps} />}
      {screen === "notifications" && <NotificationsSettingsScreen {...screenProps} />}
      {screen === "language" && <LanguageSettingsScreen {...screenProps} />}
      {screen === "security" && <SecuritySettingsScreen {...screenProps} />}
      {screen === "password" && <PasswordSettingsScreen {...screenProps} />}
    </div>
  );
}
